import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Icon } from "../../lib/icon";
import { StaggerItem } from "../common/Reveal";
import PillButton from "../common/PillButton";
import { useStaffing } from "../forms/StaffingProvider";

export default function SolutionCard({ solution }) {
  const { open } = useStaffing();
  const isWorkforce = solution.slug === "workforce-transformation";
  return (
    <StaggerItem>
      <div
        className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink-800/50 p-8 transition-colors duration-500 hover:border-sky-400/40"
        data-testid={`solution-card-${solution.slug}`}
      >
        <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-400">
          <Icon name={solution.icon} className="h-6 w-6" />
        </div>
        <Link to={`/solutions/${solution.slug}`} className="group/title">
          <h3 className="font-heading text-xl font-bold tracking-tight text-white transition-colors group-hover/title:text-sky-300 lg:text-2xl">
            {solution.name}
          </h3>
        </Link>

        <div className="mt-5 space-y-4 text-sm leading-relaxed text-slate-400">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Problem</span>
            <p className="mt-1.5">{solution.problem}</p>
          </div>
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">AMVI Approach</span>
            <p className="mt-1.5">{solution.approach}</p>
          </div>
        </div>

        <ul className="mt-5 grid gap-2">
          {solution.capabilities.map((c) => (
            <li key={c} className="flex items-start gap-2 text-sm text-slate-300">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-sky-400" />
              {c}
            </li>
          ))}
        </ul>

        <div className="mt-8 flex flex-wrap items-center gap-4">
          {isWorkforce ? (
            <PillButton variant="outline" size="md" onClick={open} testId={`solution-cta-${solution.slug}`}>
              {solution.cta}
            </PillButton>
          ) : (
            <PillButton variant="outline" size="md" to="/contact" testId={`solution-cta-${solution.slug}`}>
              {solution.cta}
            </PillButton>
          )}
          <Link
            to={`/solutions/${solution.slug}`}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-sky-400 hover:text-sky-300"
            data-testid={`solution-learn-${solution.slug}`}
          >
            Learn More
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    </StaggerItem>
  );
}
